export const Panel = ({ title, sub, children, testId, right = null }) => (
  <section className="ahu-card p-5 sm:p-7 fade-in" data-testid={testId}>
    <div className="flex flex-wrap items-start justify-between gap-3 mb-5">
      <div>
        <h2 className="font-display text-xl text-charcoal">{title}</h2>
        {sub && <p className="text-sm text-ink-soft mt-1 max-w-2xl">{sub}</p>}
      </div>
      {right}
    </div>
    {children}
  </section>
);

export const Stat = ({ n, label, testId }) => (
  <div className="rounded-xl bg-alabaster p-4" data-testid={testId}>
    <p className="font-display text-3xl text-charcoal">{n ?? "-"}</p>
    <p className="text-sm text-ink-soft mt-0.5">{label}</p>
  </div>
);

export const Row = ({ label, children }) => (
  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-1 sm:gap-6 py-3 border-b border-rule last:border-0">
    <p className="text-sm text-ink-soft">{label}</p>
    <div className="text-[15px] text-charcoal sm:text-right">{children}</div>
  </div>
);

export const PrivacyNote = () => (
  <p className="text-xs text-ink-soft mt-4" data-testid="admin-privacy-note">
    Admins see accounts and counts only. Action Plans and what people write in them stay private to each person.
  </p>
);
